/**
 * Converts minutes to milliseconds.
 *
 * @param {number} minutes
 * @return {number}
 */
export const minutesToMilliseconds = (minutes) => 1000 * 60 * minutes;
